import { render, staticRenderFns } from "./NoSearchResult.vue?vue&type=template&id=64226651&scoped=true&"
import script from "./NoSearchResult.vue?vue&type=script&lang=ts&"
export * from "./NoSearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./NoSearchResult.vue?vue&type=style&index=0&id=64226651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64226651",
  null
  
)

export default component.exports